export const API_URL = 'buffers/category'
export const ROUTE_NAME = 'buffers/category'
